// It is important to get all steps in that package
import * as adfCustomSteps from '@atlaskit/adf-schema/steps';
// It is important to get all steps in that package
import * as atlaskKitCustomSteps from '@atlaskit/custom-steps';
import { ACTION, ACTION_SUBJECT, EVENT_TYPE, fireAnalyticsEvent } from '@atlaskit/editor-common/analytics';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { Step } from '@atlaskit/editor-prosemirror/transform';
import { addSynchronyErrorAnalytics } from '../../analytics';
import { initialize } from '../../events/initialize';
import { pluginKey } from './plugin-key';
import { PluginState } from './plugin-state';
var enforceCustomStepRegisters = function enforceCustomStepRegisters() {
  var tryToRegisterStep = function tryToRegisterStep(obj) {
    for (var _i = 0, _Object$values = Object.values(obj); _i < _Object$values.length; _i++) {
      var _customStep$prototype;
      var customStep = _Object$values[_i];
      // I know this seems awful
      // But unfortunate ProseMirror does not expose the jsonID property p
      // @ts-expect-error
      var id = customStep === null || customStep === void 0 || (_customStep$prototype = customStep.prototype) === null || _customStep$prototype === void 0 ? void 0 : _customStep$prototype.jsonID;
      if (typeof id === 'string') {
        try {
          // We are trying to re-register the steps here
          // in the normal flow, those custom step should be already registred
          // So, it should throw an expeception
          // @ts-expect-error
          Step.jsonID(id, customStep);
        } catch (e) {
          // This mean the step was already registred.
          // It is ok to ignore this exception.
        }
      }
    }
  };

  // @ts-expect-error
  tryToRegisterStep(atlaskKitCustomSteps);
  // @ts-expect-error
  tryToRegisterStep(adfCustomSteps);
};
export var createPlugin = function createPlugin(dispatch, providerFactory, providerResolver, collabProviderCallback, options, featureFlags, pluginInjectionApi) {
  enforceCustomStepRegisters();
  return new SafePlugin({
    key: pluginKey,
    state: {
      init: function init(config) {
        return PluginState.init(config);
      },
      apply: function apply(transaction, prevPluginState, _oldEditorState, _newEditorState) {
        var pluginState = prevPluginState.apply(transaction);
        dispatch(pluginKey, pluginState);
        return pluginState;
      }
    },
    props: {
      decorations: function decorations(state) {
        var _pluginKey$getState;
        return (_pluginKey$getState = pluginKey.getState(state)) === null || _pluginKey$getState === void 0 ? void 0 : _pluginKey$getState.decorations;
      }
    },
    filterTransaction: function filterTransaction(tr, state) {
      var pluginState = pluginKey.getState(state);
      var collabInitialiseTr = tr.getMeta('collabInitialised');

      // Don't allow transactions that modifies the document before
      // collab-plugin is ready.
      if (collabInitialiseTr) {
        return true;
      }
      if (!(pluginState !== null && pluginState !== void 0 && pluginState.isReady) && tr.docChanged) {
        return false;
      }
      return true;
    },
    view: function view(_view) {
      var _pluginInjectionApi$a, _pluginInjectionApi$a4;
      var addErrorAnalytics = addSynchronyErrorAnalytics(_view.state, _view.state.tr, featureFlags, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions);
      var onSyncUpError = function onSyncUpError(attributes) {
        var _pluginInjectionApi$a2, _pluginInjectionApi$a3;
        var fireAnalyticsCallback = fireAnalyticsEvent((_pluginInjectionApi$a2 = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a3 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a3 === void 0 || (_pluginInjectionApi$a3 = _pluginInjectionApi$a3.sharedState.currentState()) === null || _pluginInjectionApi$a3 === void 0 ? void 0 : _pluginInjectionApi$a3.createAnalyticsEvent) !== null && _pluginInjectionApi$a2 !== void 0 ? _pluginInjectionApi$a2 : undefined);
        fireAnalyticsCallback({
          payload: {
            action: ACTION.NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS,
            actionSubject: ACTION_SUBJECT.EDITOR,
            eventType: EVENT_TYPE.OPERATIONAL,
            attributes: attributes
          }
        });
      };
      options.onSyncUpError = onSyncUpError;
      var cleanup = collabProviderCallback(initialize({
        view: _view,
        options: options,
        providerFactory: providerFactory,
        featureFlags: featureFlags,
        editorAnalyticsApi: pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a4 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a4 === void 0 ? void 0 : _pluginInjectionApi$a4.actions
      }), addErrorAnalytics);
      providerFactory && providerFactory.subscribe('collabEditProvider', function (_name, providerPromise) {
        if (providerPromise) {
          providerPromise.then(function (provider) {
            return providerResolver(provider);
          });
        }
      });
      return {
        destroy: function destroy() {
          providerFactory.unsubscribeAll('collabEditProvider');
          if (cleanup) {
            cleanup.then(function (unsubscribe) {
              if (unsubscribe) {
                unsubscribe();
              }
            });
          }
        }
      };
    }
  });
};